import { FC } from 'react';
import useEventStatusSelector from './EventStatusSelector.hook';
import Box from 'yoda-ui/components/Box';
import SelectYoda from 'yoda-ui/components/Form/SelectYoda';
import { useYodaCreateForm, YodaFormProvider } from 'yoda-ui/yodaForm';
import { YodaSpacing } from 'yoda-ui/yodaTheme';

export const EventStatusSelector: FC = () => {
  const { eventStatusSelectorConfig, handleEventStatusChange } = useEventStatusSelector();
  const yodaFormMethods = useYodaCreateForm({ setIsValidOptional: true });

  return (
    <YodaFormProvider { ...yodaFormMethods.providerFields }>
      <Box marginRight={ YodaSpacing.large } flex={ 1 }>
        <SelectYoda disableClearable={ true } { ...eventStatusSelectorConfig } onChange={ handleEventStatusChange } />
      </Box>
    </YodaFormProvider>
  );
};
